import { render, staticRenderFns } from "./LawStatisticList.vue?vue&type=template&id=656bd093&scoped=true"
import script from "./LawStatisticList.vue?vue&type=script&lang=js"
export * from "./LawStatisticList.vue?vue&type=script&lang=js"
import style0 from "./LawStatisticList.vue?vue&type=style&index=0&id=656bd093&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656bd093",
  null
  
)

export default component.exports